<template>


  <div class="history" id="history_div">
    <el-dialog title="Detail" :visible.sync="dialogDetail" width="80%">
      <p v-if="viewData.redeem_type === 0" class="title">Store</p>
      <p v-if="viewData.redeem_type === 0" class="con">{{viewData.store_name}}</p>
      <p class="title">SN</p>
      <p class="con">{{viewData.sn}}</p>
      <p class="title">Redeem Type</p>
      <p class="con">{{redeemTypeStr[viewData.redeem_type]}}</p>
      <p class="title">Preset</p>
      <p class="con">{{viewData.preset}}</p>
      <p class="title">Balance</p>
      <p class="con">{{viewData.balance}}</p>
    </el-dialog>
    <div class="history-content">
      <div class="history-list">
        <div class="pc-nav">
          <img @click="clickGoIndex" src="../assets/img/backIcon.png" alt />
          <ul>
            <li :class="{ active: index === num }" v-for="(item, index) in dayArr" :key="item"
              @click="changeActive(index)">
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="list">
          <table>
            <tr>
              <td>Status</td>
              <td>Time</td>
              <td>Store</td>
              <td>Voucher</td>
              <td>SN</td>
            </tr>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>
                <img class="table-img" src="../assets/img/gift_used_1.png" v-if="item.status == 1" alt />
                <img class="table-img" src="../assets/img/gift_used_2.png" v-if="item.status == 2" alt />
              </td>
              <td>{{ item.use_time }}</td>
              <td style="word-break:break-word;">{{ item.store_name }}<br />{{ item.store_id }}</td>
              <td>{{ item.voucher_name }}</td>
              <td>{{ item.sn }}</td>
            </tr>
          </table>

          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
            :page-size="show_num" layout=" prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
      <div class="phone-list">
        <div class="fix">
          <div class="ph-list-title">
            <img @click="clickGoIndex" class="ph-header-img" src="../assets/img/backIcon.png" alt />

            <div class="ph-header" style="font-family: 'Poppins-Medium';">
              History
            </div>
          </div>
          <ul>
            <li :class="{ active: index === num }" v-for="(item, index) in dayArr" :key="item"
              @click="changeActive(index)">
              {{ item }}
            </li>
          </ul>
        </div>

        <van-list v-model="loading" :finished="finished" @load="onLoad" :offset="10" :immediate-check="false"
          style="padding: 15px 12px;">
          <div id="list-content">
            <table class="table">
              <tr>
                <td style="height:40px;width:15%;">Status</td>
                <td style="height:40px;width:23%;">Time</td>
                <td style="height:40px;width:32%;">Voucher</td>
                <td style="height:40px;width:15%;">Use</td>
                <td style="height:40px;width:15%;">Detail</td>

              </tr>
              <tr v-for="(item, index) in serverData" :key="index">
                <td>
                  <img class="table-img" src="../assets/img/gift_used_1.png" v-if="item.status == 1" alt />
                  <img class="table-img" src="../assets/img/gift_used_2.png" v-if="item.status == 2" alt />
                </td>
                <td>{{ item.time }}</td>
                <td style="text-align:left;padding-left: 10px;">{{ item.voucher }}</td>
                <td class="item-sn">{{ item.use }}</td>
                <td @click="openView(item)">
                  <div class="view">view</div>
                </td>
              </tr>
            </table>
          </div>
        </van-list>

        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
          :page-size="show_num" layout="total, prev, pager, next" :total="total">
        </el-pagination> -->
        <!-- <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="page"
          :page-size="show_num" layout=" prev, pager, next" :total="total">
        </el-pagination> -->
      </div>
    </div>
  </div>
</template>

<script>
  import {
    HistoryList
  } from "@/api/account";
  export default {
    data() {
      return {
        screenWidth: document.body.clientWidth,
        tableData: [],
        page: 1,
        show_num: 6,
        start_time: "",
        end_time: "",
        total: 0,
        num: 0,
        phonetotal: 1, //总条数
        phonepage: 1, //页码
        phoneraw: 8, //每页条数
        loading: false,
        finished: false,
        data: [],
        // loadMore: false,
        serverData: [], //接受服务器的数据,
        // pageNo: 1,
        // totalNum: 1000,
        dialogDetail: false,
        dayArr: ["Current Day", "≤7 Day", "≤14 Day", "≤30 Day"],
        viewData: "",
        redeemTypeStr: {
          0: "N/A",
          1: 'Limited',
          2: 'Unlimited',
          3: 'Credit'
        }
      };
    },
    methods: {
      async getData() {
        let {
          code,
          msg,
          data
        } = await HistoryList({
          start_time: this.start_time,
          show_num: this.show_num,
          end_time: this.end_time,
          page: this.page,
        });
        if (data.error_code == "NSA_00003") {
          this.$message({
            message: "Login has expired. Please login again",
            type: "warning",
          });
          this.$router.push("/login");
        }

        // 边界判断 如果当前页码没有数据了 且 当前页码不是第一页
        if (!data.list.length && this.page !== 1) {
          this.page = 1; // 页码-1
          this.getData(); // 重新获取数据
        }

        this.tableData = data.list;
        this.total = data.count;
      },

      handleSizeChange(size) {
        this.show_num = size;
        this.getData();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.getData();
      },

      clickGoIndex() {
        this.$router.push("/");
      },

      changeActive(index) {
        this.num = index;
        if (index == "0") {
          this.end_time = this.getTime();
          this.start_time = this.getTime();
          if (this.screenWidth >= 992) {
            this.getData();
          } else if (this.screenWidth <= 992) {
            this.phonepage = 1;
            this.finished = false;
            this.getServerData();
          }
        } else if (index == "1") {
          this.end_time = this.getTime();
          this.start_time = this.aa(7);
          if (this.screenWidth >= 992) {
            this.getData();
          } else if (this.screenWidth <= 992) {
            this.phonepage = 1;
            this.finished = false;
            this.getServerData();
          }
        } else if (index == "2") {
          this.end_time = this.getTime();
          this.start_time = this.aa(14);
          if (this.screenWidth >= 992) {
            this.getData();
          } else if (this.screenWidth <= 992) {
            this.phonepage = 1;
            this.finished = false;
            this.getServerData();
          }
        } else if (index == "3") {
          console.log(this.screenWidth);
          this.end_time = this.getTime();
          this.start_time = this.aa(30);
          if (this.screenWidth >= 992) {
            this.getData();
          } else if (this.screenWidth <= 992) {
            this.phonepage = 1;
            this.finished = false;
            this.getServerData();
          }
        }
      },

      getTime() {
        var nowtime =
          new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate();
        return nowtime;
      },
      aa(day) {
        var myDate = new Date(); // 获取今天日期
        myDate.setDate(myDate.getDate() - (day - 1));
        var dateArray = [];
        var dateTemp;
        var flag = 1;
        for (var i = 0; i < day; i++) {
          dateTemp =
            myDate.getFullYear() +
            "-" +
            (myDate.getMonth() + 1) +
            "-" +
            myDate.getDate();
          dateArray.push(dateTemp);
          myDate.setDate(myDate.getDate() + flag);
        }
        return dateArray[0];
      },

      async getServerData() {
        let {
          code,
          msg,
          data
        } = await HistoryList({
          start_time: this.start_time,
          show_num: this.phoneraw,
          end_time: this.end_time,
          page: this.phonepage,
        });
        if (data.error_code == "NSA_00003") {
          this.$message({
            message: "Login has expired. Please login again",
            type: "warning",
          });
          this.$router.push("/login");
        }
        this.serverData = data.list;
      },

      async onLoad() {
        this.phonepage++;
        let {
          code,
          msg,
          data
        } = await HistoryList({
          start_time: this.start_time,
          show_num: this.phoneraw,
          end_time: this.end_time,
          page: this.phonepage,
        });

        this.serverData = [...this.serverData, ...data.list];
        this.phonetotal = data.count;
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (this.serverData.length >= this.phonetotal) {
          this.finished = true;
        }
      },
      openView(data) {
        console.log(data);
        this.viewData = data;
        this.dialogDetail = true;
      }
    },

    created() {
      this.end_time = this.getTime();
      this.start_time = this.getTime();

      if (this.screenWidth >= 992) {
        this.getData();
      }

      if (this.screenWidth <= 992) {
        this.getServerData();
      }
    },

    mounted() {
      const that = this;
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth;
          that.screenWidth = window.screenWidth;
          //document.getElementById("history_div").style.minHeight = document.documentElement.clientHeight;
        })();
      };
      window.onresize();
      let winHeight = document.documentElement.clientHeight; //视口大小
      document.getElementById("list-content").style.minHeight =
        winHeight - 30 + "px"; //调整上拉加载框高度
    },
  };
</script>

<style lang="less" scoped>
  @font-face {
    font-family: "Poppins-Light";
    src: url("../assets/font/Poppins-Light.ttf");
  }

  @font-face {
    font-family: "Poppins-Regular";
    src: url("../assets/font/Poppins-Regular.ttf");
  }

  @font-face {
    font-family: "Poppins-Medium";
    src: url("../assets/font/Poppins-SemiBold.ttf");
  }

  @font-face {
    font-family: "Poppins-SemiBold";
    src: url("../assets/font/Poppins-Bold.ttf");
  }

  .history {
    height: 100%;
    width: 100%;
    background-color: #eee;

    .history-content {
      background-color: #eee;
      width: 100%;
      height: 100%;
      position: fixed;
      position: relative;
    }
  }

  /deep/.el-dialog {
    margin-top: 25vh !important;
    border-radius: 8px;

    .el-dialog__header {
      border-bottom: 1px solid #eee;
      padding: 14px 12px 10px !important;

      .el-dialog__headerbtn {
        right: 12px;
        top: 15px;
      }

      .el-dialog__close {
        color: #1c1c1c;
      }
    }

    .el-dialog__body {
      padding: 16px 12px;
      padding-bottom: 1px;

      .title {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        color: #b8b8b8;
        margin-bottom: 5px;
      }

      .con {
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        color: #1c1c1c;
        margin-bottom: 19px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 18px;
      }
    }
  }

  // @media screen and (max-width: 992px) {
  .history-content {
    overflow: scroll;
  }

  .history {
    background-color: #eee;

    .history-list {
      display: none;
    }

    .phone-list {
      // padding: 20px;
      // color: #eee;
      background-color: #eee;
      position: relative;
      text-align: center;

      .fix {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
background: #eee;

        .ph-list-title {
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 14px 0;

          // line-height: 14px;
          .ph-header-img {
            position: absolute;
            top: 14px;
            left: 14px;
            width: 6px;
            height: 12px;
          }

          .ph-header {
            &>img {
              width: 21px;
              margin-right: 3px;
            }
          }
        }

        &>ul {
          display: flex;
          height: 50px;
          justify-content: space-between;
          align-content: center;
          align-items: center;
          font-size: 14px;
          background: #fff;
          padding: 0 12px;

          .active {
            color: #fff;
            background: #ff9900;

          }

          li {
            height: 24px;
            line-height: 50px;
            border-radius: 24px;
            line-height: 24px;
            padding: 0 10px;

          }
        }
      }


      .table {
        margin-top: 100px;
        padding: 15px 12px;
        width: 100%;
        text-align: center;
        table-layout: fixed;
        background: #fff;
        color: #1c1c1c;
        overflow: hidden;
        box-shadow: 0px 4px 14px 1px #e2e2e2;
        border-radius: 8px;

        tr {

          td {
            // border: 1px solid #342c24;
            height: 50px;
            font-size: 12px;
            overflow: hidden;
            word-break: break-word;
            padding: 0px 3px;
            vertical-align: middle;
            border: 1px solid #eee;

            .table-img {
              width: 28px;
            }

            .el-pagination {
              margin-top: 30px;

              &.el-pagination__total {
                color: #fff !important;
              }
            }
          }

          .view {
            width: 40px;
            height: 20px;
            background-color: #1cce72;
            border-radius: 2px;
            margin: auto;
            color: #fff;
            line-height: 20px;
          }

          .item-sn {
            word-break: break-all;
            //     display: -webkit-box;
            // -webkit-box-orient: vertical;
            // -webkit-line-clamp: 2;
          }
        }

        tr:nth-child(even) {
          background-color: #f8f8f8;
          ;
        }
      }
    }
  }

  // }
  // @media screen and (min-width: 992px) {
  //   .history {
  //     background: url(../assets/img/pc-bj.jpg) no-repeat;
  //     background-size: 100% 110%;
  //     .phone-list {
  //       display: none;
  //     }
  //     .history-list {
  //       position: absolute;
  //       top: 50%;
  //       left: 50%;
  //       transform: translate(-50%, -50%);
  //       width: 900px;
  //       height: 740px;
  //       text-align: center;

  //       .pc-nav {
  //         width: 100%;
  //         display: flex;
  //         align-items: center;
  //         & > img {
  //           width: 40px;
  //           height: 40px;
  //         }
  //         & > ul {
  //           width: 100%;
  //           display: flex;
  //           justify-content: space-around;
  //           color: #fff;
  //           .active {
  //             color: chocolate;
  //             &::after {
  //               content: "";
  //               margin: 0 auto;
  //               width: 20px;
  //               margin-top: 5px;
  //               height: 2px;
  //               display: block;
  //               background: chocolate;
  //             }
  //           }
  //           .li-line {
  //             width: 2px;
  //             height: 10px;
  //             background: #797874;
  //             border: none;
  //           }
  //         }
  //       }
  //       .list {
  //         width: 100%;
  //         height: 700px;
  //         table {
  //           width: 100%;
  //           font-size: 14px;
  //           text-align: center;
  //           table-layout: fixed;
  //           border: 1px solid #000;
  //           background: rgba(0, 0, 0, 0.6);
  //           color: #fff;
  //           tr {
  //             td {
  //               border: 1px solid #342c24;
  //               height: 90px;
  //               line-height: 90px;
  //               overflow: hidden;
  //               word-break: break-word;
  //             }
  //           }
  //         }
  //         .table-img {
  //           width: 60px;
  //         }
  //         .el-pagination {
  //           margin-top: 30px;
  //           .el-pagination__total {
  //             color: #fff !important;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
</style>